import React from 'react';
import { Settings } from '@pascal/pascal-core/table-line';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { CARDS_FRONT_TYPES } from '../../enums/cardTypes';
import { cardsStore } from '../../store/cardsStore';

export const SettingsContainer = observer(() => {
  const { selectedCardType, setSelectedCardType } = cardsStore;
  const t = useTranslation();
  return (
    <>
      <Settings />
      <div className='tp-settings-card-wrp'>
        <div className='tp-settings-card-holder'>
          <p className='tp-settings-card-txt'>{t('CARDS')}</p>
          <div className='tp-settings-card-inner'>
            {CARDS_FRONT_TYPES.map((item, index) => {
              if (!(index % 2)) {
                return (
                  <div key={item} className='tp-settings-card-row'>
                    <div
                      className={`tp-settings-card-row-block ${
                        selectedCardType === item ? 'active' : ''
                      } ${item}`}
                      onClick={() => setSelectedCardType(item)}
                    >
                      <div className='tp-settings-card-front card-diamonds_A' />
                      <div className='tp-settings-card-front card-clover_A' />
                      <div className='tp-settings-card-front card-pickes_A' />
                      <div className='tp-settings-card-front card-heart_A' />
                    </div>
                    <div
                      className={`tp-settings-card-row-block ${
                        selectedCardType === CARDS_FRONT_TYPES[index + 1] ? 'active' : ''
                      } ${CARDS_FRONT_TYPES[index + 1]}`}
                      onClick={() => setSelectedCardType(CARDS_FRONT_TYPES[index + 1])}
                    >
                      <div className='tp-settings-card-front card-heart_A' />
                      <div className='tp-settings-card-front card-diamonds_A' />
                      <div className='tp-settings-card-front card-pickes_A' />
                      <div className='tp-settings-card-front card-clover_A' />
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      </div>
    </>
  );
});
